import React  from "react";
import TaskInformation from "../TaskInformation";
import ValidationButton from "../ValidationButton";
const InvoiceValidation = ({ taskId }) => {
    return (
        <div>
            <h1>Invoice Validation</h1>
            <TaskInformation taskId = {taskId}/>
            <ValidationButton/>
        </div>
    );
}
export default InvoiceValidation